<div class="reject-document-modal">
  <div class="modal-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">warning</mat-icon>
      Rejeitar Documento
    </h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <div class="document-info">
      <div class="info-item">
        <mat-icon>description</mat-icon>
        <div class="info-text">
          <span class="label">Documento:</span>
          <span class="value">{{ data.fileName }}</span>
        </div>
      </div>
      <div class="info-item">
        <mat-icon>person</mat-icon>
        <div class="info-text">
          <span class="label">Profissional:</span>
          <span class="value">{{ data.professionalName }}</span>
        </div>
      </div>
    </div>

    <form [formGroup]="rejectForm" (ngSubmit)="onSubmit()">
      <div class="form-field-wrapper">
        <label class="field-label">
          <mat-icon>edit</mat-icon>
          Motivo da Rejeição <span class="required">*</span>
        </label>
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            matInput
            formControlName="reason"
            rows="5"
            placeholder="Descreva o motivo da rejeição do documento*"
            maxlength="500"
          ></textarea>
          <mat-hint align="end">
            {{ rejectForm.get('reason')?.value?.length || 0 }}/500
          </mat-hint>
          <mat-error *ngIf="hasError('reason', 'required')">
            O motivo da rejeição é obrigatório
          </mat-error>
          <mat-error *ngIf="hasError('reason', 'minlength')">
            O motivo deve ter pelo menos 10 caracteres
          </mat-error>
        </mat-form-field>
      </div>

      <div class="notification-info">
        <mat-icon class="info-icon">info</mat-icon>
        <p>
          Uma notificação será enviada automaticamente via <strong>WhatsApp</strong> para o profissional informando sobre a rejeição e o motivo.
        </p>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-actions">
    <button
      mat-button
      type="button"
      (click)="onCancel()"
      [disabled]="isSubmitting"
      class="cancel-button"
    >
      Cancelar
    </button>
    <button
      mat-raised-button
      (click)="onSubmit()"
      [disabled]="rejectForm.invalid || isSubmitting"
      class="reject-button"
    >
      <mat-icon *ngIf="!isSubmitting">close</mat-icon>
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      {{ isSubmitting ? 'Rejeitando...' : 'Rejeitar Documento' }}
    </button>
  </mat-dialog-actions>
</div>
